// @ts-nocheck
import * as React from "react";

const WrenchOutline: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" aria-hidden="true" focusable="false">
            <path
                d="M54.3 51.4c5.5 3 12.5 2.3 17.1-2.3 4.1-4.1 5.1-10 3.2-15.2l-8.7 8.7-6.1.8-1.6-1.6-1.6-1.6.8-6.1 8.7-8.7c-5.1-1.9-11.1-.9-15.2 3.2-4.6 4.6-5.4 11.6-2.3 17.1L24.9 69.4c-.5.5-.5 1.4 0 1.9l3.8 3.8c.5.5 1.4.5 1.9 0z"
                fill="none"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
        </svg>
    );
};

export default React.memo(WrenchOutline);
